<ng-container *ngIf="facade.navigationLinksDetails$ | ngrxPush as content">
  <idp-nav-links
    [content]="content"
    [secondaryContent]="secondaryFacade.secondaryNavigationContent"
    [inMobile]="isMobile"
    [isBusinessAccount]="isBusinessAccount"
    [selectedNav]="selectedNav"
    [selectedSecNav]="selectedSecondaryNav"
    [isLoggedIn]="isLoggedIn"
    (primaryNavAction)="primaryNavSelected($event)"
    (secondaryNavAction)="secondaryNavActionEvent.emit($event)"
    (analyticsEvent)="emitAdobeAnalytics($event)"
  ></idp-nav-links>
</ng-container>
